module.exports = __webpack_public_path__ + "static/media/quickreply.47fd2080.svg";